import React from 'react'
import Select from '../ui/Select'
import TextAreaField from '../ui/TextArea'
import { Ban, Check, X } from 'lucide-react'

const DeletModal = ({ 
    isOpen,
    title,
    description,
    options,
    onDelete, 
    error,
    onCancel, 
    title1, 
    buttonName, 
    icon, 
    onChange, 
    selectedReason, 
    handleCommentsOnChnage, 
    contentValue, 
    blockData 
}) => {
    if (!isOpen) return null
    const isDeactivating = !blockData?.isDisable

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm bg-opacity-40">
            <div className="bg-white rounded-xl shadow-2xl lg:w-[45rem] md:w-[45rem] w-11/12 animate-modal-slide-up">
                {/* Header */}
                <div className="flex items-center justify-between px-6 py-4 border-b bg-gray-50 rounded-t-xl">
                    <div className="flex items-center space-x-3">
                        {isDeactivating ? (
                            <Ban className="text-red-500" size={24} />
                        ) : (
                            <Check className="text-green-500" size={24} />
                        )}
                        <h3 className="text-xl font-semibold text-gray-800">
                            {isDeactivating 
                                ? `Disable (${blockData?.fullName})` 
                                : `Activate (${blockData?.fullName})`
                            }
                        </h3>
                    </div>
                    <button
                        className="p-2 text-gray-500 transition-colors rounded-full hover:text-gray-700 hover:bg-gray-200"
                        onClick={onCancel}
                    >
                        <X size={24} />
                    </button>
                </div>

                {/* Content */}
                <div className="p-6 space-y-6">
                    {isDeactivating ? (
                        <>
                            <Select 
                                label="Reason for Disable" 
                                options={options || []} 
                                value={selectedReason} 
                                onChange={onChange} 
                                className="w-full"
                            />
                            {error?.reason && (
                                <p className="-mt-2 text-sm text-red-500">
                                    {error?.reason}
                                </p>
                            )}

                            <TextAreaField 
                                placeholder="Write your comments here..." 
                                label="Comments" 
                                value={contentValue?.comments} 
                                onChange={handleCommentsOnChnage} 
                                name="comments"
                                className="w-full"
                            />
                            {error?.comments && (
                                <p className="-mt-2 text-sm text-red-500">
                                    {error?.comments}
                                </p>
                            )}
                        </>
                    ) : (
                        <div className="py-4 text-center text-gray-700">
                            <p className="text-lg">
                                Are you sure you want to activate 
                                <span className="ml-1 font-semibold">
                                    {blockData?.fullName}?
                                </span>
                            </p>
                        </div>
                    )}
                </div>

                {/* Footer Buttons */}
                <div className="flex justify-end px-6 py-4 space-x-3 border-t bg-gray-50 rounded-b-xl">
                    <button
                        className="px-6 py-2 text-gray-700 transition-colors border border-gray-300 rounded-md hover:bg-gray-100"
                        onClick={onCancel}
                    >
                        Cancel
                    </button>
                    <button
                        className={`
                            px-6 py-2 rounded-md text-white transition-colors 
                            ${isDeactivating 
                                ? 'bg-red-600 hover:bg-red-700' 
                                : 'bg-green-600 hover:bg-green-700'
                            }
                        `}
                        onClick={onDelete}
                    >
                        {buttonName || (isDeactivating ? 'Disable' : 'Activate')}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default DeletModal